import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.featuregroup.subgroup';

import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import 'leaflet.locatecontrol';
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.css';

import 'leaflet-control-custom'

import i18n from './i18n'

// uncomment for google maps layer
// import 'leaflet.gridlayer.googlemutant';

// Tweak for loading marker icon
// Default marker icon if no icon provided
import markerImg from 'images/marker-icon.png';
import markerImgShadow from 'images/marker-shadow.png';
const defaultMarkerIcon = L.icon({
    iconUrl: markerImg,
    shadowUrl: markerImgShadow,
    className: 'current-position'
});

L.Marker.prototype.options.icon = defaultMarkerIcon;

// User current position marker icon
import positionImg from 'images/current-position-icon.png';
const PositionIcon = L.icon({
    iconUrl: positionImg,
    iconSize: [31,45],
    iconAnchor: [15, 45],
    className: 'current-position'
});

// Tweaks for marker openPopup
L.Marker.prototype.openPopupBackup = L.Marker.prototype.openPopup;
L.Marker.prototype.openPopup = function() {
  if (!this._map && this.__parent) {
    this.__parent._group.on('spiderfied', this.doneSpiderfy, this);
    this.__parent.spiderfy();
  }
  else {
    this.openPopupBackup();
  }
}
L.Marker.prototype.doneSpiderfy = function() {
  this.__parent._group.off('spiderfied', this.doneSpiderfy, this);
  if (this) {this.openPopupBackup()}
}

const maps = {
  markers: [],
  mapCenter: null,
  currentPosition: null,
  boundingBox: null,
  leafletMap: null,
  leafletCluster: null,
  lgViewport: null,
  container: null,
  searchParams: {},
  init(search){
    // console.log('Enter in maps.init')
    // if (document.getElementById('app')) {
    //   i18n.locale = document.getElementById('app').getAttribute('data-locale')  
    // }
    if (document.getElementById('map')) {
      maps.render()
    } else if (document.querySelector('.map-container')) { 
      // console.log(`Get Current Position ${maps.shouldGeolocate()}`)
      if (maps.shouldGeolocate()) {
        // html results are get via js because position is needed
        maps.setPosition().then(_ => {
          search.getHTML(maps)
        });
      }
      
      let btn = document.getElementById('toggleMapModal')
      if (btn.offsetWidth === 0 && btn.offsetHeight === 0) {
        // desktop
        maps.lgViewport = true;
        maps.load('.map-container', search)
      } else {
        maps.lgViewport = false;
        // view port smaller than lg
        document.getElementById('mapModal').addEventListener('shown.bs.modal', event => {
          maps.load('.modal-map-results-container', search);
          btn.querySelector('span').innerHTML = btn.getAttribute('data-btn-hide')
        })
        document.getElementById('mapModal').addEventListener('hide.bs.modal', event => {
          btn.querySelector('span').innerHTML = btn.getAttribute('data-btn-show')
        })
      }
    }
  },
  shouldGeolocate(){
    return document.querySelector('.map-container') && document.querySelector('.map-container').getAttribute('data-map-geolocate') === 'true'
  },
  shouldTrackMapMove(){
    return document.querySelector('.map-container') && document.querySelector('.map-container').getAttribute('data-map-track-move') === 'true'
  },
  defaultCenter(){
    let attr = document.querySelector('.map-container') && document.querySelector('.map-container').getAttribute('data-map-default-center')
    if (attr) {
      return attr.split(',').map(x => Number(x.replace(/\[|\]/, '')))  
    } else {
      return null
    }
  },
  resultsCount(){
    return document.getElementById('search-results-count') && document.getElementById('search-results-count').getAttribute('data-results-count')
  },
  positionAvailable(){
    return (maps.currentPosition != null)
  },
  boundingBoxAvailable(){
    return (maps.boundingBox != null)
  },
  getPosition(){
    if (window.navigator.geolocation) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    } else {
      console.log('Sorry, browser does not support geolocation!')  
    }
  },
  setPosition(){
    return new Promise((resolve, reject) => {
      if (maps.currentPosition == undefined) {
        // // (DEV) set currentPosition to default coordinates
        // maps.currentPosition = new L.latLng(40.41694, -3.70361)
        // resolve()
        // get user currentPosition
        maps.getPosition()
        .then((position) => {
          maps.currentPosition = new L.latLng(position.coords.latitude, position.coords.longitude);
          resolve()
        })
        .catch((err) => {
          console.log('Error getting user current position');
          resolve()
        });
      } else {
        resolve()
      }
    })
  },
  appendCoordSeachParams(searchParams){
    if (maps.positionAvailable()) {
      maps.searchParams.append('lat', maps.currentPosition.lat);
      maps.searchParams.append('lon', maps.currentPosition.lng);
    }
    return searchParams
  },
  appendCenterSearchParams(){
    if (maps.mapCenter) {
      maps.searchParams.append('lat', maps.mapCenter.lat);
      maps.searchParams.append('lon', maps.mapCenter.lng);
    }
    return maps.searchParams
  },
  appendBBoxSearchParams(includeCenter=true){
    if (maps.boundingBoxAvailable()) {
      maps.searchParams.append('bounding_box', maps.boundingBox.toBBoxString());
      if (includeCenter) {
        maps.searchParams = maps.appendCenterSearchParams()
      }
      maps.searchParams = maps.appendMapResultsSearchParams()
    }
    return maps.searchParams
  },
  appendMapResultsSearchParams(){
    if (!maps.lgViewport) {
      maps.searchParams.append('map_results', '1');
    }
    return maps.searchParams
  },
  updateSearchParams(){
    maps.searchParams.delete('near')
    if (maps.searchParams.get('key') && maps.searchParams.get('key').match(/areas/)){
      maps.searchParams.delete('key')
      maps.searchParams.delete('value')
    }
    if (maps.searchParams.get('parent_title') && maps.searchParams.get('parent_title').match(/areas/)) {
      maps.searchParams.delete('parent_title')
    }
    return maps.searchParams
  },
  searchPath(useBoundingBox){
    let url = new URL(window.location)
    maps.searchParams = url.searchParams
    maps.searchPathName = url.pathname
    maps.searchParams.append('map', '1');
    if (useBoundingBox) {
      maps.updateSearchParams()
      maps.appendBBoxSearchParams()
      // maps.searchParams.append('sort', '_score')
      maps.searchPathName = maps.searchPathName.replace(/(.*\/areas).*/, '$1')
    } else {
      maps.appendCoordSeachParams()
      maps.appendMapResultsSearchParams()
    }
    return maps.searchPathName + '?' + maps.searchParams
  },
  load(container, search){
    if (maps.shouldGeolocate()) {
      maps.setPosition()
      .then((_) => {
        maps.getHTML(container, search);
      })
    } else {
      maps.getHTML(container, search);
    }
  },
  getHTML(container, search, useBoundingBox=false){
    // console.log('Enter in maps.getHTML')
    fetch(maps.searchPath(useBoundingBox), { headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }}).then(response => response.text()).then(html => {
      document.querySelector('#search-map-container').innerHTML = '';
      document.querySelector(container).innerHTML = html
      maps.render(useBoundingBox).then((_) => {
        maps.bindMarkersPopUp();
        if (maps.shouldTrackMapMove()){
          maps.leafletMap.on('dragend zoomend', e => {
            maps.boundingBox = maps.leafletMap.getBounds()
            maps.mapCenter = maps.leafletMap.getCenter()
            search.getHTML(maps, true)
          })
          maps.leafletMap.on('reload', e => {
            maps.boundingBox = maps.leafletMap.getBounds()
            maps.mapCenter = maps.leafletMap.getCenter()
            maps.getJSON()
            search.getHTML(maps, true)
          })
        }
      })
    })
  },
  getJSON(useBoundingBox=true){
    fetch(maps.searchPath(useBoundingBox), { headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }}).then(response => response.json()).then((data) => {
      maps.addMarkers(data)
      let btn = document.querySelector('div.leaflet-control.search-btn-control')
      btn.querySelector('button i').classList.remove('fa-spin')
      btn.classList.add('d-none')
    })
  },
  render(useBoundingBox=false){
    // console.log('Enter in maps.render')
    return new Promise((resolve, reject) => {
      let map_id = 'map'
      
      let map_container = document.getElementById(map_id)
      if (map_container != null) {
        let markers_data = JSON.parse(document.getElementById(map_id).getAttribute('data-markers'))
        
        let layer = new L.TileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png")
        // uncomment for google maps layer
        // let layer = new L.gridLayer.googleMutant({type: "roadmap"});

        maps.leafletMap = new L.Map(map_id, {
          layers: layer
        });

        // init empty markers array
        maps.markers = []

        maps.leafletCluster = new L.markerClusterGroup();
        maps.leafletMap.addLayer(maps.leafletCluster);
        maps.addMarkers(markers_data)
        
        if (maps.markers.length === 1) {
          maps.markers[0].openPopup();
          maps.leafletMap.setZoom(16)
        }

        if (maps.markers.length > 0) {
          // center the map
          let bounds = useBoundingBox ? maps.boundingBox : new L.LatLngBounds(markers_data);
          
          if (!useBoundingBox && maps.currentPosition != undefined) {
            if (maps.shouldGeolocate()){
              new L.marker(maps.currentPosition, {alt: i18n.translate('current_position'), icon: PositionIcon}).addTo(maps.leafletMap)
            }
            if (bounds.isValid() && bounds.contains(maps.currentPosition)) {
              // console.log(`currentPosition ${currentPosition} is inside markers bounds`)
              // take only 35 nearest markers
              bounds = new L.LatLngBounds(markers_data.slice(0,35));
            }
          }
          if (bounds.isValid()) {
            maps.leafletMap.fitBounds(bounds);  
          }
        } else {
          // center map at default site coordinates if no markers available
          maps.leafletMap.setView(maps.defaultCenter(), 16)
        }

        maps.addEventListeners()

        L.control.locate({
          drawMarker: false,
          // from leaflet.locatecontrol/src/L.Control.Locate.js:
          // redefined to add aria attributes, removed btn text
          createButtonCallback(container, options) {
            var link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', container);
            link.title = i18n.translate('locate_in_map');
            link.role = 'button';
            link.href = '#';
            link.ariaLabel = i18n.translate('locate_in_map');
            var icon = L.DomUtil.create('i', options.icon, link);
            icon.ariaHidden = 'true'
            
            return { link: link, icon: icon };
          },
        }).addTo(maps.leafletMap);

        resolve();
      }
    })
  },
  addEventListeners(){
    // fix marker popup position
    maps.leafletMap.on('popupopen', e => {
      var px = maps.leafletMap.project(e.target._popup._latlng); // find the pixel location on the map where the popup anchor is
      px.y -= e.target._popup._container.clientHeight/2; // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
      maps.leafletMap.panTo(maps.leafletMap.unproject(px),{animate: true}); // pan to new center
    });

    if (maps.shouldTrackMapMove()){
      // get more markers button
      let controlBtn = maps.renderSearchButton()
      controlBtn.addTo(maps.leafletMap)
      let btn = controlBtn.container
      btn.addEventListener('click', e => {
        btn.querySelector('i').classList.add('fa-spin')
        maps.leafletMap.fire('reload', e)
      })
      
      // TODO
      // if (useBoundingBox && markers.length == 0) {
        // let controlAlert = maps.renderSearchAlert()
        // controlAlert.addTo(maps.leafletMap)
      // }

      maps.leafletMap.on('moveend', e => {
        // Show searchButton if not all results loaded in map
        // markers count less than resultsCount
        if (maps.markers != null && maps.markers.length < maps.resultsCount() || window.location.href.match(/areas/) != null || window.location.href.match(/\?near/) != null) {
          btn.classList.remove('d-none')
        } else {
          btn.classList.add('d-none')
        }

        // Show resultsCount if only one markerCluster and not all results loaded in map
        maps.leafletMap.eachLayer(function (layer) {
          // layer._childClusters.length == 1 &&
          if (layer.getChildCount && layer._childCount == maps.markers.length && layer._childCount < maps.resultsCount()){
            // markerCluster._defaultIconCreateFunction:
            let childCount = layer._childCount;

            let c = ' marker-cluster-';
            if (childCount < 10) {
              c += 'small';
            } else if (childCount < 100) {
              c += 'medium';
            } else {
              c += 'large';
            }

            let icon2 = new L.DivIcon({ html: '<div style="width:45px;height:35px;margin-left: 3px;margin-top: 3px;"><span style="font-size:1.3em"><b> ' + maps.resultsCount() + '</b></span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(50, 40) });
            layer.setIcon(icon2);
            // hide searchButton if cluster tweaked
            btn.classList.add('d-none')
          }
        });
      })
    }
  },
  addMarkers(markers_data){
    let markers_group = L.featureGroup.subGroup(maps.leafletCluster);
    let new_markers = []

    for (var i = 0; i < markers_data.length; i++) {
      let marker_data = markers_data[i]
      if (maps.markers.find(x => x.options.trigger == marker_data.trigger) === undefined){
        let icon
        if (marker_data.icon != undefined && marker_data.icon.length > 0) {
          icon = L.icon({
            iconUrl: marker_data.icon || icon,
            shadowUrl: marker_data.icon || iconShadow,
            popupAnchor:  [18, 4]
          })
        } else {
          icon = defaultMarkerIcon
        }
        
        let marker = new L.marker([marker_data.lat,markers_data[i].lng], {alt: marker_data.title, icon: icon, trigger: marker_data.trigger})
          .bindPopup(marker_data.popup);
        markers_group.addLayer(marker);
        maps.markers.push(marker);
      }
    }
    return markers_group.addTo(maps.leafletMap)
  },
  renderSearchButton(){
    return L.control.custom({
      position: 'topleft',
      content : '<button type="button" class="form-btn text-uppercase fw-bold" style="padding: .5rem 0.7rem;font-size:0.9em;margin-top:0.25em">'+
                '    <i class="fas fa-sync fa-fw" aria-hidden="true"></i>  ' + 
                i18n.translate('search_in_area') + 
                '</button>',
      classes : 'search-btn-control d-none',
      style: {
        fontSize: '1.1em',
        cursor: 'pointer'
      }
    })
  },
  renderSearchAlert(){
    return L.control.custom({
      position: 'topright',
      content : '<div class="alert alert-danger text-uppercase" role="alert">'+
                '    <i class="fas fa-exclamation-circle fa-fw" aria-hidden="true"></i>'+
                i18n.translate('no_results') + 
                '</div>',
      style: {
        fontSize: '1.1em'
      }
    })
  },
  bindMarkersPopUp(){
    // console.log('entering bindMarkersPopUp')
    if (maps.leafletMap != undefined) {
      // bind to different container depending viewPort
      let container;
      if (maps.lgViewport) {
        container = document.querySelector('#search-results-container')
      } else {
        container = document.querySelector('.modal-map-results-container')
        document.dispatchEvent(new CustomEvent('favorites.reload', {'detail': {'container':container}}))
      }
      
      container.querySelectorAll('.open-map-marker').forEach((button) => {
        button.addEventListener('click', (e) => {
          // console.log(`clicked ${button.getAttribute('data-map-marker-trigger')}`)
          e.preventDefault();
          if (maps.markers.length) {
            let marker = maps.markers.find(x => x.options.trigger === button.getAttribute('data-map-marker-trigger'))
            if (marker != undefined) {
              maps.leafletMap.setView(marker.getLatLng(), 17, {animate: true})
              marker.openPopup();
              e.preventDefault();
            }
          }
        });
      });
    }
  }
}

export default maps
